// Where the last successful sign-in method persists so the login page can
// label it ("Last used"). Per-browser on purpose: the account's canonical
// method is user.provider from the backend, but the label answers "how did I
// sign in on this device" — a user with both paths wants the one they last
// used here.
export type AuthMethod = 'password' | 'google' | 'github'

export const AUTH_METHOD_STORAGE_KEY = 'aura_last_auth'

// localStorage access can throw (blocked storage, quota modes) — the label is
// a nicety, so every failure degrades to "no hint" rather than breaking login.
export function loadLastAuthMethod(): AuthMethod | null {
  try {
    const value = localStorage.getItem(AUTH_METHOD_STORAGE_KEY)
    return value === 'password' || value === 'google' || value === 'github' ? value : null
  } catch {
    return null
  }
}

export function storeLastAuthMethod(method: AuthMethod): void {
  try {
    localStorage.setItem(AUTH_METHOD_STORAGE_KEY, method)
  } catch {
    // The next visit simply shows no label; only persistence is lost.
  }
}
